const BASE_URL = 'https://resellerproapp.com';

const PAGE_SEO = {
  '/': {
    title: 'Reseller Pro: Tools for Resellers',
    description:
      'Reseller Pro helps resellers manage inventory, track sales across multiple channels, log expenses and mileage, and analyze profit — all in one app.',
    canonicalPath: '/',
    ogType: 'website',
    ogImage: `${BASE_URL}/og-image.png`,
    twitterCard: 'summary_large_image',
  },
  '/pricing': {
    title: 'Pricing - Reseller Pro Inventory Management ($11/mo)',
    description:
      'Reseller Pro plans start at $11/month for inventory, expenses, mileage, and analytics, or $20/month for higher limits and a larger AI assistant allowance. 7-day free trial.',
    canonicalPath: '/pricing',
    ogType: 'website',
    ogImage: `${BASE_URL}/og-image.png`,
    twitterCard: 'summary_large_image',
  },
  '/features': {
    title: 'Features - Reseller Pro Inventory, Expense & Mileage Tracking',
    description:
      'Track inventory across antique booths, flea markets, and online channels, log expenses and sourcing mileage, print barcode labels, and see your real profit per sale.',
    canonicalPath: '/features',
    ogType: 'website',
    ogImage: `${BASE_URL}/og-image.png`,
    twitterCard: 'summary_large_image',
  },
  '/help': {
    title: 'Help & Support — Reseller Pro',
    description:
      'Get help with Reseller Pro. Browse support articles, learn how to manage inventory, track sales, and get the most out of your reselling tools.',
    canonicalPath: '/help',
    ogType: 'website',
    ogImage: `${BASE_URL}/og-image.png`,
    twitterCard: 'summary_large_image',
  },
};

export { BASE_URL, PAGE_SEO };
